"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Upload = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 35 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.0572 24.9006L21.9698 11.6006H27.7431C28.3068 11.6006 28.589 10.9191 28.1905 10.5206L17.8549 0.185C17.6075 -0.0616667 17.2068 -0.0616667 16.9601 0.185L6.62457 10.5206C6.22531 10.9191 6.50753 11.6006 7.07123 11.6006H12.6127L12.7001 24.9006C12.7001 25.2472 12.9816 25.5287 13.3283 25.5287H21.4298C21.7764 25.5287 22.0572 25.2472 22.0572 24.9006Z",
  fill: "black"
}), /*#__PURE__*/_react.default.createElement("path", {
  opacity: "0.399959",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.8889 35.7404C27.6615 35.7404 26.6667 34.7449 26.6667 33.5182C26.6667 32.2915 27.6615 31.296 28.8889 31.296C30.1163 31.296 31.1111 32.2915 31.1111 33.5182C31.1111 34.7449 30.1163 35.7404 28.8889 35.7404ZM20.7407 35.7404C19.5133 35.7404 18.5185 34.7449 18.5185 33.5182C18.5185 32.2915 19.5133 31.296 20.7407 31.296C21.9681 31.296 22.963 32.2915 22.963 33.5182C22.963 34.7449 21.9681 35.7404 20.7407 35.7404ZM31.8519 27.4071H2.96296C1.32667 27.4071 0 28.7338 0 30.3701V36.6664C0 38.3027 1.32667 39.6293 2.96296 39.6293H31.8519C33.4882 39.6293 34.8148 38.3027 34.8148 36.6664V30.3701C34.8148 28.7338 33.4882 27.4071 31.8519 27.4071Z",
  fill: "black"
}));

var _default = Upload;
exports.default = _default;